export const notJunk = "HN$nC";
export default {notJunk};